import BGMPlayer from "./BGMPlayer";

export default BGMPlayer;
